module.exports = __webpack_public_path__ + "img/Group 1@2x.52c48f1c.png";